<span [innerHTML]="svgContent()"></span>
